import { AnimationEvent } from '@angular/animations';
import {
  Component, Inject, OnInit, OnDestroy, Optional, Input, ElementRef, Output, EventEmitter
} from '@angular/core';

import { toastAnimations, ToastAnimationState } from './toast-animation';
import { ToastData, TOAST_DATA, ToastSeverity } from './toast.model';
import { ToastRef } from './toast.ref';

@Component({
  selector: 'sondermind-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  animations: [toastAnimations.fadeToast],
  standalone: false
})
export class ToastComponent implements OnInit, OnDestroy {
  private intervalId: number;

  animationState: ToastAnimationState = 'default';

  @Input()
    origin?: ElementRef;

  @Input()
    message: string;

  @Input()
    severity: ToastSeverity;

  @Output()
    dismissed = new EventEmitter<void>();

  @Input()
    showIcon = true;

  @Input()
    autoHide = true;

  constructor(
  @Optional()
  @Inject(TOAST_DATA)
    data: ToastData,

    @Optional()
    readonly ref: ToastRef
  ) {
    // initialize from toast data from the modal service
    if (data) {
      this.origin = data.origin;
      this.message = data.message;
      this.severity = data.severity;
    }
  }

  ngOnInit() {
    if (this.isDismissable && this.autoHide) {
      this.intervalId = window.setTimeout(() => this.dismissToast(), 5000);
    }
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearTimeout(this.intervalId);
    }
  }

  get isDismissable() {
    return this.dismissed.observers.length || this.ref != null;
  }

  cssClass() {
    // return css class based on notification severity
    switch (this.severity) {
      case 'success':
        return { color: 'sondermind-success', iconType: 'done' };
      case 'warning':
        return { color: 'sondermind-warning', iconType: 'warning' };
      case 'info':
        return { color: 'sondermind-info', iconType: 'info' };
      case 'danger':
        return { color: 'sondermind-error', iconType: 'error' };
      default:
        return { color: 'sondermind-notification', iconType: null };
    }
  }

  dismissToast() {
    this.animationState = 'closing';
    if (this.intervalId) {
      clearTimeout(this.intervalId);
    }
  }

  onFadeFinished(event: AnimationEvent) {
    //  Animate out overlay after 5 seconds
    const { toState } = event;
    const isFadeOut = (toState as ToastAnimationState) === 'closing';
    const itFinished = this.animationState === 'closing';

    // actually close the thing
    if (isFadeOut && itFinished) {
      if (this.ref) {
        this.ref.close();
      }

      this.dismissed.next();
    }
  }
}
